import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';

const ROLE_COLORS = { general_manager:'#EEEDFE', project_manager:'#E1F5EE', warehouse_manager:'#E6F1FB', foreman:'#E6F1FB', main_crew:'#EAF3DE', warehouse_worker:'#FAECE7', subcontractor:'#FAEEDA' };
const ROLE_TEXT = { general_manager:'#3C3489', project_manager:'#085041', warehouse_manager:'#0C447C', foreman:'#185FA5', main_crew:'#27500A', warehouse_worker:'#712B13', subcontractor:'#633806' };

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [showInvite, setShowInvite] = useState(false);
  const [invite, setInvite] = useState({ first_name:'', last_name:'', email:'', role:'main_crew' });
  const [msg, setMsg] = useState('');

  const load = () => axios.get('/api/users').then(r => setUsers(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const filtered = users.filter(u => !search || `${u.first_name} ${u.last_name} ${u.email}`.toLowerCase().includes(search.toLowerCase()));

  const sendInvite = async () => {
    if (!invite.first_name || !invite.email) { setMsg('Name and email required'); return; }
    try {
      await axios.post('/api/users/invite', invite);
      setMsg('Invite sent!'); setShowInvite(false); setInvite({ first_name:'', last_name:'', email:'', role:'main_crew' }); load();
    } catch(e) { setMsg(e.response?.data?.error || 'Failed'); }
  };

  const deactivate = async (id) => {
    if (!window.confirm('Deactivate this user?')) return;
    await axios.patch(`/api/users/${id}`, { status: 'inactive' }); load(); setSelected(null);
  };

  return (
    <Layout>
      <div style={{marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>User management</h1>
          <p style={{color:'#888',fontSize:'13px',marginTop:'4px'}}>{users.filter(u=>u.status==='active').length} active users</p>
        </div>
        <button onClick={()=>setShowInvite(!showInvite)} style={{padding:'9px 18px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>+ Invite user</button>
      </div>
      {msg && <div style={{background:'#EAF3DE',borderRadius:'8px',padding:'10px 14px',color:'#27500A',fontSize:'13px',marginBottom:'14px'}}>{msg}</div>}

      {showInvite && (
        <div style={{background:'#fff',borderRadius:'12px',border:'2px solid #185FA5',padding:'20px',marginBottom:'20px'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>Invite new user</h2>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'16px'}}>
            {[['first_name','First name'],['last_name','Last name'],['email','Email address']].map(([k,l]) => (
              <div key={k}>
                <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>{l}</label>
                <input value={invite[k]} onChange={e=>setInvite({...invite,[k]:e.target.value})}
                  style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
              </div>
            ))}
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Role</label>
              <select value={invite.role} onChange={e=>setInvite({...invite,role:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="general_manager">General Manager</option>
                <option value="project_manager">Project Manager</option>
                <option value="warehouse_manager">Warehouse Manager</option>
                <option value="foreman">Foreman / Lead</option>
                <option value="main_crew">Main crew</option>
                <option value="warehouse_worker">Warehouse worker</option>
                <option value="subcontractor">Subcontractor</option>
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
            <button onClick={()=>setShowInvite(false)} style={{padding:'8px 16px',background:'#fff',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',cursor:'pointer'}}>Cancel</button>
            <button onClick={sendInvite} style={{padding:'8px 16px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>Send invite</button>
          </div>
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'1fr 320px',gap:'16px'}}>
        <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',overflow:'hidden'}}>
          <div style={{padding:'14px 16px',borderBottom:'1px solid #f5f5f5'}}>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or email..."
              style={{width:'100%',padding:'8px 12px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
          </div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
            <thead><tr style={{background:'#f8f8f8'}}>
              <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Name</th>
              <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Role</th>
              <th style={{padding:'10px 14px',textAlign:'center',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Items out</th>
              <th style={{padding:'10px 14px',textAlign:'left',color:'#666',fontWeight:'600',fontSize:'11px',textTransform:'uppercase'}}>Status</th>
            </tr></thead>
            <tbody>
              {filtered.map((u,i) => (
                <tr key={i} onClick={()=>setSelected(u)} style={{borderTop:'1px solid #f5f5f5',cursor:'pointer',background:selected?.id===u.id?'#E6F1FB':'transparent'}}>
                  <td style={{padding:'10px 14px'}}>
                    <div style={{fontWeight:'600',color:'#222'}}>{u.first_name} {u.last_name}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>{u.email}</div>
                  </td>
                  <td style={{padding:'10px 14px'}}>
                    <span style={{background:ROLE_COLORS[u.role]||'#f0f0f0',color:ROLE_TEXT[u.role]||'#555',padding:'2px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'500',textTransform:'capitalize'}}>
                      {u.role?.replace(/_/g,' ')}
                    </span>
                  </td>
                  <td style={{padding:'10px 14px',textAlign:'center',color:u.overdue_count>0?'#A32D2D':'#555'}}>{u.items_out||0}</td>
                  <td style={{padding:'10px 14px'}}>
                    <span style={{display:'inline-flex',alignItems:'center',gap:'5px',fontSize:'12px'}}>
                      <span style={{width:'7px',height:'7px',borderRadius:'50%',background:{active:'#3B6D11',invited:'#854F0B',inactive:'#888'}[u.status]||'#888',display:'inline-block'}} />
                      {u.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          {!selected ? (
            <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'40px',textAlign:'center',color:'#888',fontSize:'13px'}}>Select a user to view their profile</div>
          ) : (
            <div style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'20px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'16px',paddingBottom:'16px',borderBottom:'1px solid #f5f5f5'}}>
                <div style={{width:'44px',height:'44px',borderRadius:'50%',background:ROLE_COLORS[selected.role]||'#f0f0f0',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',fontWeight:'700',color:ROLE_TEXT[selected.role]||'#555'}}>
                  {selected.first_name?.[0]}{selected.last_name?.[0]}
                </div>
                <div>
                  <div style={{fontSize:'15px',fontWeight:'700',color:'#222'}}>{selected.first_name} {selected.last_name}</div>
                  <div style={{fontSize:'12px',color:'#888',textTransform:'capitalize'}}>{selected.role?.replace(/_/g,' ')}</div>
                </div>
              </div>
              {[['Email',selected.email],['Items out',selected.items_out||0],['Overdue',selected.overdue_count||0],['Sites',selected.site_count||0],['Status',selected.status]].map(([l,v],i) => (
                <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid #f5f5f5',fontSize:'13px'}}>
                  <span style={{color:'#888'}}>{l}</span>
                  <span style={{fontWeight:'500',color:l==='Overdue'&&v>0?'#A32D2D':'#222'}}>{v}</span>
                </div>
              ))}
              <div style={{marginTop:'14px',display:'flex',gap:'8px'}}>
                {selected.status === 'active' && (
                  <button onClick={()=>deactivate(selected.id)} style={{padding:'7px 14px',background:'#FCEBEB',color:'#A32D2D',border:'1px solid #F09595',borderRadius:'8px',fontSize:'12px',cursor:'pointer'}}>
                    Deactivate
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
